import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=a97b5afa&scoped=true"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"
import style0 from "./Jumbotron.vue?vue&type=style&index=0&id=a97b5afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97b5afa",
  null
  
)

export default component.exports